module.exports = __webpack_public_path__ + "img/mobile.1b88db43.png";